"use strict";

$(document).ready(function () {
  if ($('.brand_slider').length > 0) {
    brand_slider();
  }

  if ($('body#manufacturer').length > 0) {
    brandFilterSlider();
  }

  if ($('.brand_slider .swiper-pagination-bullet').length <= 1) {
    if (!$('.brand_slider .swiper-pagination').hasClass('hide')) {
      $('.brand_slider .swiper-pagination').addClass('hide');
    }
  } else {
    $('.brand_slider .swiper-pagination').removeClass('hide');
  }

  $(window).on('resize', function () {
    if ($('.brand_slider .swiper-pagination-bullet').length <= 1) {
      if (!$('.brand_slider .swiper-pagination').hasClass('hide')) {
        $('.brand_slider .swiper-pagination').addClass('hide');
      }
    } else {
      $('.brand_slider .swiper-pagination').removeClass('hide');
    }
  });
});
$(document).ready(function () {
  $(document).on('change keyup', 'input[name=brand]', function (e) {
    var search = $(this);
    var sv = search.val();
    var brandItem = $('.brand-item');
    var brandBlock = $('.brand-block');
    var brandBlockUl = brandBlock.find('ul');
    brandItem.each(function (i) {
      var thisName = $(this);
      var name = $(this).data('name');
      var list = thisName.parents('ul');
      var brandBlock = thisName.parents('.brand-block');
      var blockLetter = brandBlock.find('.letter');

      if (kmpSearch(sv.toLowerCase(), name.toLowerCase()) != -1) {
        thisName.parents('li').removeAttr("style");
        thisName.parents('li').removeClass('hide');
      } else {
        thisName.parents('li').css('display', 'none');
        thisName.parents('li').addClass('hide');
      }

      listCheck(list, blockLetter);
    });
    brandBlockUl.each(function (i) {
      if ($(this).find('li').length > 0) {} else {
        $(this).parents('.brand-block').css('display', 'none');
      }
    });
  });
  $(document).on('click', '.alphabet-filter .selection', function (e) {
    e.stopPropagation();
    e.preventDefault();
    var thisClick = $(this);

    if (!$(this).hasClass('disabled') && !$(this).hasClass('all')) {
      var thisLetter = thisClick.attr('data-filter');
      var brandBlock = $('.brand-block');
      brandBlock.each(function (i) {
        if ($(this).find('.letter').attr('data-this-letter') === thisLetter) {
          $(this).removeAttr("style");
        } else {
          $(this).css('display', 'none');
        }
      });
    } else if ($(this).hasClass('all')) {
      var brandBlock = $('.brand-block');
      brandBlock.each(function (i) {
        $(this).removeAttr("style");
      });
    }
  });

  function listCheck(list, letter) {
    var listItems = list.find('li');
    var listItemsArr = [];
    listItems.each(function () {
      if ($(this).hasClass('hide')) {
        listItemsArr.push(false);
      } else {
        listItemsArr.push(true);
      }
    });

    if (containOnlyFalse(listItemsArr)) {
      letter.addClass('empty');
      letter.parents('.brand-block').css('display', 'none');
    } else {
      letter.removeClass('empty');
      letter.parents('.brand-block').removeAttr("style");
    }
  }

  function containOnlyFalse(arr) {
    var val = arr.every(function (x) {
      return x === false;
    });
    return val;
  }
});

function kmpSearch(pattern, text) {
  if (pattern.length == 0) return 0;
  var lsp = [0];

  for (var i = 1; i < pattern.length; i++) {
    var j = lsp[i - 1];

    while (j > 0 && pattern.charAt(i) != pattern.charAt(j)) {
      j = lsp[j - 1];
    }

    if (pattern.charAt(i) == pattern.charAt(j)) j++;
    lsp.push(j);
  }

  var j = 0;

  for (var i = 0; i < text.length; i++) {
    while (j > 0 && text.charAt(i) != pattern.charAt(j)) {
      j = lsp[j - 1];
    }

    if (text.charAt(i) == pattern.charAt(j)) {
      j++;
      if (j == pattern.length) return i - (j - 1);
    }
  }

  return -1; // Not found
}

function brand_slider() {
  var swiper = new Swiper('.brand_slider .swiper-container', {
    slidesPerView: 2,
    spaceBetween: 37,
    pagination: {
      el: '.brand_slider .swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.brand_slider .swiper-button-next',
      prevEl: '.brand_slider .swiper-button-prev'
    },
    breakpoints: {
      576: {
        slidesPerView: 3
      },
      1150: {
        slidesPerView: 5,
        spaceBetween: 67 // 67

      }
    }
  });
}

function brandFilterSlider() {
  var breakpoint = window.matchMedia('(max-width: 1151px)');
  var mySwiper;

  var breakpointChecker = function breakpointChecker() {
    if (breakpoint.matches === false) {
      if (mySwiper !== undefined) {
        mySwiper.destroy(true, true);
      }

      return;
    } else if (breakpoint.matches === true) {
      return enableSwiper();
    }
  };

  var enableSwiper = function enableSwiper() {
    mySwiper = new Swiper('.swiper-container.alphabet-slider', {
      slidesPerView: 8,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.search-brands .swiper-button-next',
        prevEl: '.search-brands .swiper-button-prev'
      }
    });
  };

  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
}